export default __webpack_public_path__ + "static/appicon256-762bb3a336b744dc359e80265cfb0981.png";